import React from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { Tiles } from '@Components/Tiles'
import { TilesCardLook } from '@Components/Tiles/Card/Look'
import { useTileSettings } from '@Components/Tiles/settings'
import {
  LookListBlock as LookListBlockGraphQL,
  PagePresentation,
  PageType,
} from '@Generated/graphql'
import { BlockContext } from '@Globals/CMS/Context'
import { getPins } from '@Globals/CMS/LookHelpers'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { Image } from '@Globals/Image'

const LookListBlock = ({
  data,
  id,
}: {
  data: LookListBlockGraphQL
  id?: string
}) => {
  const { presentation } = React.use(BlockContext)
  const { appearance, common, looks, settings } = data
  const tileSettings = useTileSettings(settings)
  const openModal = useCMSModalOpen()

  if (!looks || looks.length === 0) {
    return null
  }

  return (
    <BlockContainer
      appearance={appearance || {}}
      common={common || {}}
      id={id}
      presentation={presentation}
    >
      <Tiles settings={tileSettings}>
        {looks.map(look => (
          <TilesCardLook
            key={look.id}
            ambassadorHandle={look.ambassadorHandle || undefined}
            cardAspectRatio={tileSettings.cardAspectRatio}
            cardSize={tileSettings.cardSize}
            cardVariant={tileSettings.cardVariant}
            image={look.asset as Image}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              openModal(PageType.Look, look.id!, 'inherit', presentation)
            }}
            pins={getPins(look, id, PagePresentation.Sidebar)}
            presentation={presentation}
            sizes={tileSettings.width ? `${tileSettings.width}px` : undefined}
          />
        ))}
      </Tiles>
    </BlockContainer>
  )
}
export default LookListBlock
